import { OmsInsightSchema } from "@redotech/redo-model/analytics/oms/oms-insight";
import * as z from "zod/v4";

export const getOmsInsights = {
  name: "getOmsInsights" as const,
  input: z.object({}),
  output: z.object({ insights: z.array(OmsInsightSchema) }),
};
